import { useContext } from "react";
import userContext from "./Context";
import "./table.css";
function Alldata(){
    let ctx=useContext(userContext)

    return(<>
   
        {ctx.users.map((user, index) => (

        <center>
          <table className="table">
          <tr>
            <th>Name</th>
            <td>{user.name}</td>
          </tr>
           <tr>
            <th>Email</th>
            <td>{user.email}</td>
          </tr>
           <tr>
            <th>Password</th>
            <td>{user.password}</td>
          </tr>
           <tr>
            <th>Amount</th>
            <td>{user.amount}</td>
          </tr>
        </table>
        </center>
      ))}
    </>)
}
export default Alldata;